"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionItem_1 = __importDefault(require("./CollectionItem"));
exports.default = CollectionItem_1.default;
